<template>
  <div class="latest-news">
    <div v-if="loading" class="text-center py-8">
      <p class="text-gray-600">{{ t('common.loading') }}</p>
    </div>

    <div v-else-if="posts.length === 0" class="text-center py-8">
      <p class="text-gray-600">{{ t('blog.latest.noNews') }}</p>
    </div>

    <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <article
        v-for="post in posts"
        :key="post.id"
        class="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden"
      >
        <RouterLink :to="`/news/${post.slug}`" class="block">
          <div class="p-6">
            <div class="flex flex-wrap gap-2 mb-3">
              <span
                v-for="category in post.categories"
                :key="category.id"
                class="px-2 py-1 text-xs bg-bdc-ocre/10 text-bdc-ocre rounded-full"
              >
                {{ category.name }}
              </span>
            </div>
            <h3
              class="text-lg font-semibold text-bdc-black mb-2 hover:text-bdc-ocre transition-colors"
            >
              {{ post.title }}
            </h3>
            <p v-if="post.excerpt" class="text-gray-600 text-sm mb-4 line-clamp-2">
              {{ post.excerpt }}
            </p>
            <div class="flex items-center justify-between text-xs text-gray-500">
              <span v-if="post.author">
                {{ post.author.firstName }} {{ post.author.lastName }}
              </span>
              <span v-if="post.publishedAt">
                {{ formatDate(post.publishedAt) }}
              </span>
            </div>
          </div>
        </RouterLink>
      </article>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBlogStore } from '@/stores/blog'
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'

const { t, locale } = useI18n()
const blogStore = useBlogStore()

// Utiliser les données du store (limiter à 3 posts)
const posts = computed(() => blogStore.publicPosts.slice(0, 3))
const loading = computed(() => blogStore.isLoading)

function formatDate(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleDateString(locale.value, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

async function loadPosts() {
  // Charger les posts publics (le store gère le cache)
  //console.log('[BdC-LatestNews] Chargement des posts publics')
  const posts = await blogStore.loadPosts({
    isDraft: false,
    limit: 3,
  })
  console.log('[BdC-LatestNews] Posts chargés:', posts.length, posts)
}

onMounted(() => {
  loadPosts()
})
</script>
